import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ForwardIcon = (props: IconProps) => (
  <Icon w="18px" h="18px" viewBox="0 0 18 18" {...props}>
    <path d="M10.5 6.375v-3l5.25 5.25-5.25 5.25V10.8c-3.75 0-6.375 1.2-8.25 3.825.75-3.75 3-7.5 8.25-8.25Z" />
  </Icon>
);

export default memo(ForwardIcon);
